// Zambian cities with approximate coordinates for autocomplete + geolocation.
// Sourced from public geographic data; only used client-side for suggestions and
// nearest-city detection (no backend calls). Sorted alphabetically.
export const ZAMBIAN_CITIES = [
  { name: "Chingola", lat: -12.5297, lng: 27.8567, province: "Copperbelt" },
  { name: "Chinsali", lat: -10.5500, lng: 32.0667, province: "Muchinga" },
  { name: "Chipata", lat: -13.6333, lng: 32.6500, province: "Eastern" },
  { name: "Choma", lat: -16.8000, lng: 26.9833, province: "Southern" },
  { name: "Kabwe", lat: -14.4469, lng: 28.4464, province: "Central" },
  { name: "Kafue", lat: -15.7667, lng: 28.1833, province: "Lusaka" },
  { name: "Kalulushi", lat: -12.8398, lng: 28.0864, province: "Copperbelt" },
  { name: "Kapiri Mposhi", lat: -13.9720, lng: 28.6653, province: "Central" },
  { name: "Kasama", lat: -10.2129, lng: 31.1808, province: "Northern" },
  { name: "Kitwe", lat: -12.8024, lng: 28.2132, province: "Copperbelt" },
  { name: "Livingstone", lat: -17.8419, lng: 25.8544, province: "Southern" },
  { name: "Luanshya", lat: -13.1367, lng: 28.4166, province: "Copperbelt" },
  { name: "Lusaka", lat: -15.3875, lng: 28.3228, province: "Lusaka" },
  { name: "Mansa", lat: -11.1997, lng: 28.8940, province: "Luapula" },
  { name: "Mazabuka", lat: -15.8500, lng: 27.7500, province: "Southern" },
  { name: "Mbala", lat: -8.8383, lng: 31.3667, province: "Northern" },
  { name: "Mongu", lat: -15.2482, lng: 23.1275, province: "Western" },
  { name: "Mpika", lat: -11.8333, lng: 31.4500, province: "Muchinga" },
  { name: "Mufulira", lat: -12.5500, lng: 28.2400, province: "Copperbelt" },
  { name: "Nakonde", lat: -9.3378, lng: 32.7581, province: "Muchinga" },
  { name: "Ndola", lat: -12.9587, lng: 28.6366, province: "Copperbelt" },
  { name: "Petauke", lat: -14.2500, lng: 31.3167, province: "Eastern" },
  { name: "Siavonga", lat: -16.5389, lng: 28.7089, province: "Southern" },
  { name: "Solwezi", lat: -12.1667, lng: 26.4000, province: "North-Western" },
];

// Haversine great-circle distance in km between two lat/lng points.
export function haversineKm(a, b) {
  const R = 6371;
  const toRad = (d) => (d * Math.PI) / 180;
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
}

// Find the closest Zambian city to a given {lat,lng}. Falls back to Lusaka.
export function nearestCity(coords) {
  if (!coords) return ZAMBIAN_CITIES.find((c) => c.name === "Lusaka");
  let best = null;
  let bestDist = Infinity;
  for (const c of ZAMBIAN_CITIES) {
    const d = haversineKm(coords, c);
    if (d < bestDist) {
      bestDist = d;
      best = c;
    }
  }
  return best || ZAMBIAN_CITIES.find((c) => c.name === "Lusaka");
}

// Case-insensitive prefix + substring city suggestions.
export function suggestCities(query, limit = 6) {
  const q = (query || "").trim().toLowerCase();
  if (!q) return [];
  const starts = [];
  const contains = [];
  for (const c of ZAMBIAN_CITIES) {
    const n = c.name.toLowerCase();
    if (n.startsWith(q)) starts.push(c);
    else if (n.includes(q)) contains.push(c);
  }
  return [...starts, ...contains].slice(0, limit);
}
